export default "__VITE_ASSET__30fae74c__"